import React from "react";
import { Image } from "react-bootstrap";

const ImageBlk = ({ src, classNames, alt }) => {
    return (
        <div className={classNames[0]}>
            <Image src={src} alt={alt} className={classNames[1]} fluid />
        </div>
    );
};

export default ImageBlk;
